import axios from "axios";
import { GEOAIAPI_BASE_URL } from "./base_urls";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class GeoAIInterface {
    constructor() {
        this.session = axios.create({
            baseURL: GEOAIAPI_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${localStorage.getItem("tiles_api_auth0_token")}`
            }
        });
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new GeoAIInterface(singletonEnforcer);
        }

        return this[singleton];
    }

    detect = (data) => this.session.post(`v1/geoai/inferences`, data)
    getGeoAIRequests = (skip, limit) => this.session.get(`v1/geoai/inferences?skip=${skip}&limit=${limit}`)
    getGeoAIRequestUsage = () => this.session.get(`v1/geoai/inferences/usage`)
}

export default GeoAIInterface;